// window.onload = function () {
//   getRem(1920, 100)
// };
// window.onresize = function () {
//   getRem(1920, 100)
// };
// function getRem (pWidth, pRem) {
//   let html = document.getElementsByTagName('html')[0];
//   let oWidth = document.body.clientWidth || document.documentElement.clientWidth;
//   html.style.fontSize = oWidth / pWidth * pRem + 'px';
// }

/*
* @ pwidth 设计稿的宽度
* @ prem 你要1rem比多少px  我的是1rem比100px
* */
(function (doc, win, pwidth, prem) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      docEl.style.fontSize = clientWidth / pwidth * prem + 'px';
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window, 1920, 100);




// WEBPACK FOOTER //
// ./src/assets/js/rem.js